import {
  useGetRankQuery,
  useGetMyNutritionTipsQuery,
} from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';
import { NutritionContainer } from '@screens/NutritionPage/NutritionContainer';
import { useNutritionViewModal } from '@/features/NutritionsViewModels/NutritionProducts.view.model';


export const NutritionPage = () => {
  
  const {
    data: foodsData,
    isLoading: isFoodLoading,
    isError: isFoodsError,
  } = useGetRankQuery();

  const {
    data: nutritionTipsData,
    isLoading: isNutritionTipsLoading,
    isError: isNutritionError,
  } = useGetMyNutritionTipsQuery();

  const { foodFormulaData, isFoodFormulaLoading, isErrorInFormula } =
    useNutritionViewModal();


  return (
    <div className="bg-background-secondary" data-testid="nutrition-page">
      <NutritionContainer
        tipsData={{
          tips: nutritionTipsData?.nutrition_tips,
          isLoading: isNutritionTipsLoading,
          isError: isNutritionError,
        }}
        foodsData={{
          foodRanks: foodsData,
          isLoading: isFoodLoading,
          isError: isFoodsError,
        }}
        formulasData={{
          formulas: foodFormulaData,
          isLoading: isFoodFormulaLoading,
          isError: isErrorInFormula,
        }}
      />
    </div>
  );
};
